import { MultiColumnAutoCompleteActionType } from './multiColumnAutoCompleteActionType';
import { MultiColumnAutoCompleteState, QuantifyAction } from './types';

export function multiColumnAutoCompleteReducer(
  state: MultiColumnAutoCompleteState,
  action: QuantifyAction,
): MultiColumnAutoCompleteState {
  const { type, payload } = action;
  switch (type) {
    case MultiColumnAutoCompleteActionType.SET:
      return {
        ...state,
        ...payload,
      };

    default:
      return state;
  }
}
